export default __webpack_public_path__ + "media/images/reticle-dbff413218a2f5843b32cf2fb9968eb4.png";